import { render } from "./address_details.html?vue&type=template&id=ef7b8886&scoped=true&external"
import script from "./address_details.js?vue&type=script&lang=js&external"
export * from "./address_details.js?vue&type=script&lang=js&external"

import "./AddressDetails.vue?vue&type=style&index=0&id=ef7b8886&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef7b8886"]])

export default __exports__